import ChooseYourPlan from 'components/choose-your-plan/ChooseYourPlan';
import EnterProgressBar from 'components/enter/ProgressBar';
import React, { ReactElement } from 'react';

interface Props extends Record<string, unknown>{
  /** The component to render */
  componentName: keyof typeof components; 
  /** The props for the component */
  componentProps: {};
  /** Whether the component for 'componentName' should render any of its variants*/
  variant: string;
  /** The fallback component that 'componentName' should render if there are no variants (i.e this is likely to be a plasmic component tree) */
  children: ReactElement;
}

const components = {
  enterProgressBar: EnterProgressBar,
  chooseYourPlan: ChooseYourPlan
};

/** A component that we can put into plasmic and then never have to mess about with plasmic's configuration ever again. Eventually, we can then
 * use these components in place when plasmic goes in the bin.
 * 
 * You can also provide it with a variant from plasmic, and it'll change according to that variant.
 */
const DaymadeRepoComponent = (props: Props) => {
  const Component = components[props.componentName] as any;
  if (!Component) {
    throw new Error('Component name ' + props.componentName + ' was not valid');
  }
  return (
    <Component variant={props.variant} {...props.componentProps}>{props.children}</Component>
  );
};

export default DaymadeRepoComponent;
